/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Extended_AccessInputs */

const fr_admin_subscription_rights_extended_access = /** @type {(inputs: Admin_Subscription_Rights_Extended_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès 6h-23h`)
};

/**

* @param {Admin_Subscription_Rights_Extended_AccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_extended_access = /** @type {((inputs?: Admin_Subscription_Rights_Extended_AccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Extended_AccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_extended_access(inputs)
});